"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeCluster = exports.addCluster = exports.setCurrentClustersAction = void 0;
const ADD = "ducks/currentClusters/ADD";
const SET = "ducks/currentClusters/SET";
const REMOVE = "ducks/currentClusters/REMOVE";
exports.setCurrentClustersAction = currentClusters => ({
    type: SET,
    currentClusters: currentClusters
});
exports.addCluster = (cluster) => ({
    type: ADD,
    cluster: cluster
});
exports.removeCluster = (cluster) => ({
    type: REMOVE,
    cluster: cluster
});
const initialState = null;
function currentClusters(state = initialState, action) {
    switch (action.type) {
        case SET:
            return action.currentClusters;
        case ADD: {
            let cluster = action.cluster;
            let newState = state.slice(0);
            newState.push(action.cluster);
            // TODO: maybe should not be in a reducer
            // Add cluster label to vectors
            cluster.vectors.forEach(sample => {
                if (Array.isArray(sample.clusterLabel)) {
                    if (!sample.clusterLabel.includes(cluster.label)) {
                        sample.clusterLabel.push(cluster.label);
                    }
                }
                else {
                    sample.clusterLabel = [cluster.label];
                }
            });
            return newState;
        }
        case REMOVE: {
            let cluster = action.cluster;
            if (state.includes(cluster)) {
                let newState = state.slice(0);
                newState.splice(newState.indexOf(cluster), 1);
                // TODO: maybe should not be in a reduce
                // Remove cluster label from vectors
                cluster.vectors.forEach(sample => {
                    if (Array.isArray(sample.clusterLabel)) {
                        sample.clusterLabel.splice(sample.clusterLabel.indexOf(cluster.label), 1);
                    }
                    else {
                        sample.clusterLabel = [];
                    }
                });
                return newState;
            }
            else {
                return state;
            }
        }
        default:
            return state;
    }
}
exports.default = currentClusters;
